import Form from "../../../forms/Form";
import Chosen from "../../../forms/Inputs/Select/Chosen";

import {gsap} from "gsap";
import PhoneInput from "../../../../templates/src/Components/PhoneInput/PhoneInput";
import RentalPrivate from "@modules/rental/views/private/private.js";

const RentalSummary = {
    init(animate) {
        this.el = $('[module="rental"][section="summary"]');
        if (!this.el.length) return;

        this.formSection = this.el.find('.form.section');
        this.form = this.formSection.find('[form="RentalOrder"]')
        this.formTabs = this.formSection.find('nav.formTabs .person')
        this.formCompanySection = this.formSection.find('.billingCompany');
        this.ageInput = this.formSection.find("input#age").parent();

        this.thankYouAlert = $('[module="rental"].thank-you')
        this.thankYouAlertHide = this.thankYouAlert.find('button.close');
        this.similar = this.el.find('.similar .vehicle');
        this.age = this.el.find('[name="age"]');

        this.printButton = this.el.find("button.printAsPDF");

        this.start();
        this.bind();
        if (animate) this.animate();
        Chosen.init(this.form);
    },

    start() {
        PhoneInput.init();
        RentalPrivate.bindDiscounts();
    },

    bind() {
        Form.bind(this.form);

        this.formTabs.on('click', (evt) => this.changeBillingPerson($(evt.currentTarget)));
        this.similar.on('click', (evt) => this.changeSimilar(evt));
        this.age.on('change', (evt) => this.changeAge(evt));
        this.printButton.on('click', (evt) => this.printOffer(evt) );

        this.thankYouAlertHide.on('click', (event) => {
            if (Rental.isAdmin()) {
                RentalSummary.hideThankYou();
                setTimeout(() => {
                    location.reload();
                }, 500);
            } else {
                window.location.href = "/" + window.T.rental.base_url;
            }
        });

        this.el.find('.TEST').click((evt)=>{
            this.showThankYou();
        });

        window.addEventListener('keydown', function(event) {
            if (event.ctrlKey && event.key === 'p') {
                event.preventDefault();
                // Ctrl+P (or Command+P on Mac) is pressed
                RentalSummary.printButton.trigger("click");
            }
        });
    },

    async changeAge(evt) {
        const input = $(evt.currentTarget);
        const url = "/" + window.T.rental.base_url + "/" + window.T.rental.sections.summary.url
        let accessory = null;

        if (input.val() < 25) {
            accessory = 7;
        }

        if (input.val() > 65) {
            accessory = 8;
        }

        if (accessory) {
            const response = await Rental.load(url, {accessory: accessory, count: 1, warning: 'warning_age'})
            this.el.find('.summaryAccessories').replaceWith($(response).find('.summaryAccessories'));
        } else {
            await Rental.load(url, {accessory_age: false});
        }
    },

    animate() {
        gsap.timeline()
            .from(this.el.find('[block="left"] article'), {opacity: 0, stagger: 0.15, y: 100, duration: 0.7, clearProps: true}, 0)
            .from(this.el.find('[block="right"] > div'), {opacity: 0, stagger: 0.15, y: 100, duration: 0.7, clearProps: true}, 0)
            .from(this.el.find('.similar'), {opacity: 0, y: 100, duration: 0.7, clearProps: true}, 1)
    },

    changeSimilar(evt) {
        evt.preventDefault();
        const url = "/" + window.T.rental.base_url + "/" + window.T.rental.sections.summary.url
        Rental.load(url, {vehicle: $(evt.currentTarget).attr('item')}, 0)
    },

    changeBillingPerson(tab) {
        tab.addClass("active").siblings().removeClass("active");
        let personType = tab.data("person-type");
        this[personType]();
    },

    company() {
        this.formCompanySection.addClass('visible');
        this.ageInput.addClass("hidden").removeClass("required");
        this.updateCompanyInputs(true);
    },

    person() {
        this.formCompanySection.removeClass('visible');
        this.ageInput.addClass("required").removeClass("hidden");
        this.updateCompanyInputs(false);
    },

    updateCompanyInputs(state) {
        this.formCompanySection.find('input').each((i, input) => {
            $(input).removeClass('required');
            let required = $(input).data("optional-required")

            if (state === true && required === true) {
                $(input).parent().addClass("required");
            }
        })
    },

    showThankYou(response) {
        const formData = JSON.parse(response.data.post);
        this.thankYouAlert.find(".reservationNumber").text(response.order_number || response.leadID);
        this.thankYouAlert.find(".reservationEmail").text(formData.email);

        gsap.timeline()
            .to(this.thankYouAlert, {display:"flex", opacity:1, duration:0.5}, 0)
            .from(this.thankYouAlert.find('[block]'), {opacity:0, scale:0.5, duration:0.5, ease:"back.out"}, 0)
            .from(this.thankYouAlert.find('main > *'), {y: "100%", opacity:0, stagger:0.15, duration:0.3},0.3)
    },

    hideThankYou(response) {
        gsap.timeline()
            .to(this.thankYouAlert, {display:"none", opacity:0, duration:0.5}, 0);
    },

    printOffer(evt) {
        const button = $(evt.currentTarget);
        const pageTitleBackup = window.document.title;

        let filename = button.data('filename');

        window.document.title = filename;
        window.print();
        window.document.title = pageTitleBackup;
    }
}

export default RentalSummary;